import { generateLegalMoves } from '../movegen/generate.js'
import { positionKey } from '../position/key.js'
import type { Position } from '../position/position.js'
import type { Square } from '../primitives/square.js'

/**
 * The en passant square, but only when a capture onto it is actually legal.
 *
 * FIDE counts positions as identical when the same player is to move, the
 * pieces stand on the same squares, and the same moves are available. A pawn
 * double-push that no enemy pawn can answer changes the FEN but changes none of
 * those things, so it must not break a repetition claim.
 */
export const capturableEnPassant = (pos: Position): Square | null => {
  if (pos.epSquare === null) return null
  return generateLegalMoves(pos).some((move) => move.kind === 'enPassant') ? pos.epSquare : null
}

export const repetitionKey = (pos: Position): string => positionKey(pos, capturableEnPassant(pos))

export const bumpKey = (counts: ReadonlyMap<string, number>, key: string): Map<string, number> => {
  const next = new Map(counts)
  next.set(key, (next.get(key) ?? 0) + 1)
  return next
}

export const occurrences = (counts: ReadonlyMap<string, number>, key: string): number =>
  counts.get(key) ?? 0
